module.exports = __webpack_public_path__ + "static/media/reset.d0ca9770.jpg";